import React from "react"
import Button from "@mui/material/Button"

const McpUsersTable = ({
  users,
  onResetPassword,
  onViewConfig,
  onRevoke,
  onActivate,
}) => {
  const formatDate = (date) => {
    if (!date) return "-"
    return new Date(date).toLocaleDateString()
  }

  const userList = Array.isArray(users) ? users : []

  if (!userList.length) {
    return (
      <div className="empty-state">
        <p>No MCP users found</p>
      </div>
    )
  }

  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>Email</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {userList.map((user) => (
            <tr
              key={user.id}
              className={user.status === "revoked" ? "revoked" : ""}
            >
              <td>{user.mcpUserEmail || "-"}</td>
              <td>
                <span className={`status-badge ${user.status}`}>
                  {user.status}
                </span>
              </td>
              <td>{formatDate(user.createdAt)}</td>
              <td className="actions-cell">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => onViewConfig(user)}
                >
                  Config
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => onResetPassword(user)}
                >
                  Reset Password
                </Button>
                {user.status === "active" ? (
                  <Button
                    size="small"
                    variant="outlined"
                    color="error"
                    onClick={() => onRevoke(user.mcpUserId)}
                  >
                    Revoke
                  </Button>
                ) : (
                  <Button
                    size="small"
                    variant="outlined"
                    color="success"
                    onClick={() => onActivate(user.mcpUserId)}
                  >
                    Activate
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default McpUsersTable
